import { IAttachment } from "../typings/filterEntities";

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function noop(...args: any[]): any {}

export function isImageMime(mime: string | undefined) {
  return mime && mime.indexOf("image") > -1;
}

export function isValidImageAttachment(att: IAttachment) {
  return !!(att.mimeType && isImageMime(att.mimeType) && att.resizableUrl);
}

export const CUSTOM_LINK_MIME = "application/x-mx-link";

export function isLinkMime(mime: string | undefined) {
  return mime && mime === CUSTOM_LINK_MIME;
}

export function quoteString(str: string) {
  return `“${str}”`;
}

// https://stackoverflow.com/a/25050893/564163
export function getUrlOpener(loadingContent = "Loading…") {
  const linkWindow: Window | null = window.open("", "_blank");

  if (linkWindow) {
    linkWindow.opener = null;
    linkWindow.document.write(loadingContent);
  }

  return {
    closeWindow() {
      if (linkWindow) {
        linkWindow.close();
      }
    },
    getWindow() {
      return linkWindow;
    },
    openUrl(url: string) {
      if (linkWindow) {
        linkWindow.location.href = url;
      }
    },
  };
}

export async function downloadInNewWindow(
  startDownload: () => Promise<string | null>,
  loadingContent?: string,
) {
  const urlOpener = getUrlOpener(loadingContent);
  try {
    const url = await startDownload();
    if (!url) {
      urlOpener.closeWindow();
    } else {
      urlOpener.openUrl(url);
    }
  } catch (err) {
    urlOpener.closeWindow();
    throw err;
  }
}
